import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'react-bootstrap';
import ChartCard from './ChartCard';
import MarketBarChart from './MarketBarChart';
import MarketCostTable from './MarketCostTable';
import FlightTypeChart from './FlightTypeChart';

const SourceMarketSection = ({ sourceMarket, flightType, darkMode }) => {
  return (
    <React.Fragment>
      <Row className="mb-4">
        <Col lg={6}>
          <ChartCard
            id="market-distribution"
            title="Source Market Distribution"
            icon="fa fa-bar-chart"
            headerColor="#4e73df"
            darkMode={darkMode}
          >
            <MarketBarChart data={sourceMarket} />
          </ChartCard>
        </Col>
        <Col lg={6}>
          <ChartCard
            id="market-cost"
            title="Average Cost per Market"
            icon="fa fa-money"
            headerColor="#1cc88a"
            darkMode={darkMode}
          >
            <MarketCostTable data={sourceMarket} />
          </ChartCard>
        </Col>
      </Row>
      <Row className="mb-4">
        <Col lg={12}>
          <ChartCard
            id="flight-type-distribution"
            title="Flight Type Distribution"
            icon="fa fa-plane"
            headerColor="#36b9cc"
            darkMode={darkMode}
          >
            <FlightTypeChart data={flightType} />
          </ChartCard>
        </Col>
      </Row>
    </React.Fragment>
  );
};

SourceMarketSection.propTypes = {
  sourceMarket: PropTypes.arrayOf(
    PropTypes.shape({
      market: PropTypes.string.isRequired,
      total: PropTypes.number.isRequired,
      confirmed: PropTypes.number.isRequired,
      avgCost: PropTypes.number.isRequired,
    })
  ).isRequired,
  flightType: PropTypes.arrayOf(
    PropTypes.shape({
      type: PropTypes.string.isRequired,
      count: PropTypes.number.isRequired,
      totalSpend: PropTypes.number.isRequired,
    })
  ).isRequired,
  darkMode: PropTypes.bool.isRequired,
};

export default SourceMarketSection;
